import React, { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { MAP_STATE_TO_CLASSNAME } from './util/topic.js';
import { TranslationContext } from "./hooks/useTranslationContext";
import { useDSSubscription } from "./hooks/useDSSubscription";

export const DashboardItem = ({ uuid, type }) => {
    const t = useContext(TranslationContext);

    const currentRaw = useDSSubscription(`sensor/${uuid}/status/frontpage_Current`);

    const { vendor, status, name, location, state, a: alarms, w: warnings } = useDSSubscription(`sensor/${uuid}`);

    const current = useMemo(() => {
        if (currentRaw?.v !== undefined) {
            return +parseFloat(currentRaw?.v).toFixed(2);
        }
    }, [ currentRaw ]);

    if (name === undefined || location === undefined || state === undefined) {
        return null;
    }

    let level = 100;


    if (status && status.frontpage_Max !== undefined) {
        level = 100 - parseInt(Math.round(current / (+status.frontpage_Max.v) * 100));
        if (level < 0) {
            level = 0;
        } else if (level > 100) {
            level = 100;
        } else if (isNaN(level)) {
            level = 100;
        }
    }

    let additionalClasses = "item " + type;

    if (state === "RUNNING") {
        if (alarms && alarms.length > 0) {
            additionalClasses += " critical";
        } else if (warnings && warnings.length > 0) {
            additionalClasses += " warning";
        } else {
            additionalClasses += " good";
        }
    } else {
        additionalClasses += " " + MAP_STATE_TO_CLASSNAME[state];
    }

    return (
        <Link className={additionalClasses} to={`/devices/${uuid}`}>
            <div className="inner">
                <div className="columns col-gapless">
                    <div className="item__name column col-2">
                        <h2>{ name }</h2>
                        <div className="legend">
                            Name
                        </div>
                    </div>
                    <div className="item__category column col-2">
                        { t(`device_types.${type.toLowerCase()}`) }
                        <div className="legend">
                            { t('device.category') }
                        </div>
                    </div>
                    <div className="item__vendor column col-2">
                        { location || String.fromCharCode(0xA0) }
                        <div className="legend">
                            { t('device.location') }
                        </div>
                    </div>

                    <div className="item__location column col-2">
                        { vendor || String.fromCharCode(0xA0) }
                        <div className="legend">
                            { t('device.vendor') }
                        </div>
                    </div>
                    <div className="valuebg col-4">
                        <span>{current}</span> <span>
                            {( status?.frontpage_Unit ? t('sensor_units.' + status.frontpage_Unit.v) : "" ) }
                        </span>
                    </div>
                    <div className="value" style={{left: level + '%'}}>
                        Foreground
                    </div>

                </div>
            </div>
        </Link>
    );
}

